import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { applicationActions } from '../../../../actions/applicationActions';
import { roleConstants } from '../../../../constants/roleConstants';
import { applicationConstants } from '../../../../constants/applicationConstants';

class ApplicationLockButton extends Component {
  render() {
    const { application, user, handleLock, cls } = this.props;

    return !application.loading &&
      !application.is_locked &&
      application.status === applicationConstants.STATUS_ACTIVE &&
      user.role_id === roleConstants.ROLE_ADMIN ? (
      <Button className={cls} onClick={handleLock(application.id)}>
        Заблокировать
      </Button>
    ) : (
      ''
    );
  }
}

const mapStateToProps = state => {
  const { adminApplications } = state;

  return {
    adminApplications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const handleLock = id => {
    return e => dispatch(applicationActions.lock(id));
  };

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,

    handleLock
  };
};

const connectedApplicationLockButton = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ApplicationLockButton);
export { connectedApplicationLockButton as ApplicationLockButton };
